import React from "react";
import TTMWD from "./TourTravelMWD/TTMWD";

const App = () => {
  return (
    <>
      <TTMWD />
    </>
  );
};

export default App;
